module.exports = __webpack_public_path__ + "static/media/instagram-circle-color.7e73d699.svg";